module.exports = __webpack_public_path__ + "img/search-icon-white.67b01eca.svg";